export enum MoyenTransport {
    CAMION = 'CAMION',
    MOTO= 'MOTO',
    VELO= 'VELO'
} 